export class ChangePasswordData {   
    UserName: string;
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    Authentication: string;
    IsValid: boolean;
    page: string;
    pageSize: string;
    Pid: string;
    SessionTimeout: string;
    constructor(username: string, oldpassword: string, newpassword: string, confirmpassword: string, authen: string) {
        this.UserName = username;
        this.OldPassword = oldpassword;
        this.NewPassword = newpassword;
        this.ConfirmPassword = confirmpassword;
        this.Authentication = authen;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/usersecurity/changepassworddata.ts